<div class="board-list-item-wrapper  p-lr-13 m-b-20">
  <div class="board-list-item-container flex flex-row flex-wrap auto-flex">
    <div class="board-list-item-container flex flex-row flex-wrap auto-flex">
      <div class="board-list-item" [attr.data-cy]="'data-mapping-folder-item-' + container.fieldValues['Name']" *ngFor="let container of valueMappingContainers" (click)="onClickBucket(container)">
        <div class="name">{{container.fieldValues['Name']}}</div>
      </div>
    </div>
  </div>
</div>
